import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/pending-actions`;
const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

export const listActions = ({ status = "pending", actionType = "" } = {}, token) =>
  axios
    .get(API, { ...auth(token), params: { status, limit: 200, ...(actionType ? { action_type: actionType } : {}) } })
    .then(r => r.data);

export const countPending = token =>
  axios.get(`${API}/count`, auth(token)).then(r => r.data.pending_count);

export const getAction = (id, token) => axios.get(`${API}/${id}`, auth(token)).then(r => r.data);

/** `payload` is the approver's edited copy; leave it out to approve as staged. */
export const approveAction = (id, payload, token) =>
  axios.post(`${API}/${id}/approve`, payload ? { payload } : {}, auth(token)).then(r => r.data);

export const rejectAction = (id, reason, token) =>
  axios.post(`${API}/${id}/reject`, { reason }, auth(token)).then(r => r.data);

/** A bill photo or PDF as a blob URL (the file needs the login on its request). */
export const attachmentUrl = async (id, attachmentId, token) => {
  const r = await axios.get(`${API}/${id}/attachments/${attachmentId}`, { ...auth(token), responseType: "blob" });
  return { url: URL.createObjectURL(r.data), type: r.data.type || r.headers["content-type"] || "" };
};

/** The server's reason in words, whatever shape it came in. */
export const errorText = failure => {
  const detail = failure?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(d => d.msg).filter(Boolean).join("; ") || "The request was not accepted";
  if (detail && typeof detail === "object") return [detail.message, detail.hint].filter(Boolean).join(" — ");
  if (failure?.response?.status === 403) return "You do not have permission to do this";
  return failure?.message || "Could not reach the server";
};
